import ticketIcon from 'assets/icons/separator/small_separator_line.svg';
import separatorLine from 'assets/icons/ticket/ticket_dark.svg';
import React from 'react';

const ActivatedTicketListItem = (props: any) => {
    const { price, qty, name, currency } = props;
    return (
        <div className="ticket-box">
            <div className="item">
                <React.Fragment>
                    <b className="ml-1 mr-1 pl-1 pr-1">{qty}</b>
                    <span className="ml-1 pl-1">x</span>
                </React.Fragment>
                <img src={separatorLine} alt={name} className="ticketIcon" />
                <b> {name}</b>
            </div>

            <div className="item item-reverse">
                <img src={ticketIcon} alt={name} className="separator" />
                <b>
                    {
                        currency === 'INR' ? <span>&#8377;</span> : '$'
                    }
                    {((price) / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</b>
            </div>
        </div>
    );
};

export default ActivatedTicketListItem;


// WEBPACK FOOTER //
// ./src/components/platform/ticket-list/ActivatedTicketListItem.tsx